import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
  IsNumber,
} from "@/utils/type-vaildator";
import api from "./api";

// 原始接口
export interface MaterialTagResponse {
  create_time: number;
  folder_id: number;
  id: number;
  tag_name: string;
  update_time: number;
};
export class MaterialTagCreateData {
  @Required("Id cannot be empty")
  @IsNumber("Id must be a number")
  id: number;

  @Required("Tag name cannot be empty")
  @IsString("Tag name must be a string")
  tagName: string;
}

const transformAndValidateMaterialTag = (
  response: MaterialTagResponse
): MaterialTagCreateData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, MaterialTagCreateData);
  } catch (error) {
    console.error("Material Tag data validation failed:", error.message);
    throw error;
  }
};

/** 创建素材标签 */
export const materialTagCreate = async ({
  folderId,
  tagName
}: { folderId: number; tagName: string }): Promise<MaterialTagCreateData> => {
  const response = await api.post<MaterialTagResponse>('/material_tag/create', {
    folder_id: folderId,
    tag_name: tagName,
  });
  const data = transformAndValidateMaterialTag(response.data);
  return data;
};
